import request from '@/router/axios'

//获取验证图片
export function reqGet(data) {
    return request({
        url: '/api/captcha/get',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        method: 'post',
        data:data,
		transformRequest: [function (data, headers) {
		    // 对 data 进行任意转换处理
		    return JSON.stringify(data);
		}],
    })
}

//滑动或者点选验证
export function reqCheck(data) {
    return request({
        url: '/api/captcha/check',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        method: 'post',
        data:data,
		transformRequest: [function (data, headers) {
		    // 对 data 进行任意转换处理
		    return JSON.stringify(data);
		}],
    })
}
